"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BoxNote = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.604 0H9.63c.166 0 .326.065.444.18l4.032 3.947a.61.61 0 0 1 .184.435v9.592a1.813 1.813 0 0 1-.552 1.306 1.919 1.919 0 0 1-1.334.54h-8.8c-.5 0-.98-.194-1.333-.54a1.827 1.827 0 0 1-.552-1.306V1.846c0-.49.198-.96.552-1.305C2.625.195 3.104 0 3.604 0Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.07.176 3.15 3.082.887.87a.616.616 0 0 1 .128.18h-3.087c-.334 0-.653-.13-.89-.361a1.218 1.218 0 0 1-.367-.87V.055a.63.63 0 0 1 .18.12Z",
    fill: "#fff",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.591 6.86-.578.846h-4.35a.438.438 0 0 1-.305-.124.42.42 0 0 1-.126-.3c0-.234.195-.423.432-.423h4.927Z",
    fill: "#9725DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.242 8.974-.578.846H4.67a.442.442 0 0 1-.31-.122.424.424 0 0 1-.129-.3.43.43 0 0 1 .439-.424h3.57Z",
    fill: "#0061D5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.892 11.089-.267.392c-.06.095-.109.197-.144.303l-.02.073-.017.078H4.666a.436.436 0 0 1-.305-.124.418.418 0 0 1 0-.598.436.436 0 0 1 .305-.123l2.226-.001Z",
    fill: "#00C8C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.277 11.28 2.917-4.135.033.057c.046.07.148.198.338.333.287.202.501.23.501.23L8.15 11.901c-.083.11-.18.21-.29.297l-.863.638c-.092.068-.147.033-.122-.086l.234-1.086c.025-.115.098-.283.168-.383Zm4.179-5.023a.64.64 0 0 1 .255.434c-.053.13-.12.255-.197.373l-.176.257-.056-.01a1.09 1.09 0 0 1-.398-.174c-.22-.156-.394-.422-.394-.422l.176-.258c.066-.097.178-.244.281-.313l.047-.006a.707.707 0 0 1 .462.12Z",
    fill: "#000"
  })));
});
var _default = BoxNote;
exports["default"] = _default;